import * as React from "react";

const MOBILE_BREAKPOINT = 768;

/**
 * Synchronous viewport check for mount-time / event-handler decisions where the
 * stateful `useIsMobile` hasn't resolved yet (it starts undefined and only
 * settles after an effect). Client-only — returns false during SSR. Used to
 * suppress auto-focus on mobile so opening a screen/dialog doesn't pop the
 * on-screen keyboard.
 */
export function isMobileViewport(): boolean {
  if (typeof window === "undefined") return false;
  return window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`).matches;
}

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(undefined);

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
    const onChange = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    };
    mql.addEventListener("change", onChange);
    setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    return () => mql.removeEventListener("change", onChange);
  }, []);

  return !!isMobile;
}
